// WebP item icons (CHANGELOG 0.2.0, section 1). Files live in the web app's
// public folder: /assets/icons/{size}/{iconFolder}/item_{slot}_{id}_{rarity}.webp

import type { GearSlot, Rarity } from '../types';
import type { IconRarity, IconSize } from './mvpItems';

export const ICON_BASE_PATH = '/assets/icons';

/** Uncommon has no picture of its own: it shows the Common one in a green frame. */
export function iconRarity(rarity: Rarity): IconRarity {
  return rarity === 'uncommon' ? 'common' : rarity;
}

/** Icon URL for an item template, or null when the item has no WebP icon (accessories). */
export function getItemIcon(item: { id: string; slot: GearSlot; iconFolder: string | null }, rarity: Rarity, size: IconSize): string | null {
  if (!item.iconFolder) return null;
  return `${ICON_BASE_PATH}/${size}/${item.iconFolder}/item_${item.slot}_${item.id}_${iconRarity(rarity)}.webp`;
}

/** File name only, as the asset check script expects it on disk. */
export function itemIconFile(item: { id: string; slot: GearSlot }, rarity: IconRarity): string {
  return `item_${item.slot}_${item.id}_${rarity}.webp`;
}
